module.exports = __webpack_public_path__ + "src/assets/img/header-dummy-brand-3to2.jpg";